// extracted by mini-css-extract-plugin
export default {"content":"column_content__-MV1G","column":"column_column__L0Jry","default":"column_default__5mTR9","changing":"column_changing__hNHyU","modified":"column_modified__6doxP"};